"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "headings", {
  enumerable: true,
  get: function get() {
    return _headings.default;
  }
});
Object.defineProperty(exports, "text", {
  enumerable: true,
  get: function get() {
    return _text.default;
  }
});
Object.defineProperty(exports, "fontFamilies", {
  enumerable: true,
  get: function get() {
    return _fontFamilies.default;
  }
});
Object.defineProperty(exports, "paragraph", {
  enumerable: true,
  get: function get() {
    return _paragraph.default;
  }
});

var _headings = _interopRequireDefault(require("./headings"));

var _text = _interopRequireDefault(require("./text"));

var _fontFamilies = _interopRequireDefault(require("./fontFamilies"));

var _paragraph = _interopRequireDefault(require("./paragraph"));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvZGVmYXVsdC10aGVtZS90eXBvZ3JhcGh5L2luZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0FBQ0E7O0FBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBkZWZhdWx0IGFzIGhlYWRpbmdzIH0gZnJvbSAnLi9oZWFkaW5ncydcbmV4cG9ydCB7IGRlZmF1bHQgYXMgdGV4dCB9IGZyb20gJy4vdGV4dCdcbmV4cG9ydCB7IGRlZmF1bHQgYXMgZm9udEZhbWlsaWVzIH0gZnJvbSAnLi9mb250RmFtaWxpZXMnXG5leHBvcnQgeyBkZWZhdWx0IGFzIHBhcmFncmFwaCB9IGZyb20gJy4vcGFyYWdyYXBoJ1xuIl19


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/theme/src/default-theme/typography/index.js
// module id = 102
// module chunks = 0